import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom'

//Components
import { Modal, ModalBody, ModalFooter, Button, Form, Input } from "@gpstrackit/react-controls";
import CustomCard from 'Components/Card';
import { Grid } from '@mui/material';
import { NotificationManager } from 'Components/Notifications';
import { copyToClipboard } from "Core/data/Helpers";

//Actions
import {
    clearRedux,
    bulkUnpairingRequest,
    bulkUnSearchDeviceRequest
} from "Redux/actions";

const BulkUnpairing = (props) => {
    const formRef = useRef(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const { tableRef, single, getDevice, device } = props;
    //Local states
    const [serial, setSerial] = useState("")
    const [currenDevices, setCurrenDevices] = useState([])

    //Redux states
    const { loading, openModal, error, result, devices } = useSelector(state => state.bulkUnpairingRedux)

    const closeModal = () => {
        dispatch(clearRedux("DEVICES_BULK_UNPAIRING"));
        setCurrenDevices([])
        setSerial("");
    }

    const unPairing = () => {
        let unitIds = currenDevices.map((item) => (item.id))
        dispatch(bulkUnpairingRequest(unitIds))
    }

    const searchDevice = () => {
        let validateEsn = currenDevices.some((item) => item.esn === serial);
        if (!validateEsn) {
            dispatch(bulkUnSearchDeviceRequest(serial?.trim()))
        } else {
            NotificationManager.error(
                messages['devices_bulk_unpairing_the_device_is_already_added'],
                messages['devices_bulk_unpairing_title'],
                3000
            );
        }
    }

    useEffect(() => {
        console.log("result", result)
        if (result?.unpairing) {
            /*NotificationManager.success(
                single ? messages['devices_bulk_unpairing_the_device_has_been_unpaired'] : messages['devices_bulk_unpairing_device_have_been_unpaired'],
                single ? messages['devices_bulk_unpairing_unpairing_the_gps'] : messages['devices_bulk_unpairing_title'],
                3000
            );*/
            let transactionId = result?.unpairing?.transactionId;
            let message = messages["devices_bulk_unpairing_transaction_message"]
            NotificationManager.success(message, messages['devices_bulk_unpairing_title'], 10000, () => {
                copyToClipboard(transactionId, messages['common_copied']);
                navigate(`/app/transactions/list/${transactionId}`);

            }, null, '', null);

            tableRef && tableRef?.current?.getData();
            getDevice && getDevice();
            closeModal();
            dispatch(clearRedux("DEVICES_BULK_UNPAIRING", { result: null }))
        }
        if (error) {
            dispatch(clearRedux("DEVICES_BULK_UNPAIRING", { error: null }))
        }
        if (!devices?.error) {
            if (devices && devices.length > 0) {
                let validateLinkedUnitId = devices.some((item) => item.linkedUnitId !== null);
                if (validateLinkedUnitId) {
                    setSerial("")
                    let currentDevicesList = currenDevices;
                    devices.map((item) => currentDevicesList.push({ id: item?.id, label: item?.label, linkedto: item?.linkedUnit?.label || item?.linkedUnitId, esn: item?.esn }));
                    setCurrenDevices(currentDevicesList);
                    dispatch(clearRedux("DEVICES_BULK_UNPAIRING", { devices: [] }))
                } else {
                    NotificationManager.error(
                        messages['devices_bulk_unpairing_devices_mush_have_other_linked_devices'],
                        messages['devices_bulk_unpairing_title'],
                        3000
                    );
                    dispatch(clearRedux("DEVICES_BULK_UNPAIRING", { devices: [] }))
                }
            }
        } else {
            NotificationManager.error(
                messages['devices_bulk_unpairing_device_not_found'],
                messages['devices_bulk_unpairing_title'],
                3000
            );
            dispatch(clearRedux("DEVICES_BULK_UNPAIRING", { devices: [] }))
        }
    }, [result, error, devices])
    return (
        <Modal
            open={openModal}
            title={single ? messages['device_overview_unpair_device'] : messages['devices_bulk_unpairing_title']}
            handleClose={() => closeModal()}
            position="right"
            size="small"
            loading={loading}
        >
            <ModalBody>
                <div style={{ padding: '0 10px' }}>
                    {
                        !single
                            ?
                            <>
                                <Form
                                    ref={formRef}
                                    onValidSubmit={() => searchDevice()}
                                >
                                    <Grid container spacing={1}>
                                        <Grid item xs={10}>
                                            <Input
                                                label={messages['devices_bulk_unpairing_serial']}
                                                placeholder={messages['devices_bulk_unpairing_serial']}
                                                value={serial}
                                                required
                                                requiredMessage={messages['required_field']}
                                                onChange={(value) => setSerial(value)}
                                            />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <div className="bulk-button-container" style={{ marginTop: 25 }}>
                                                <Button
                                                    className="btn-dark-blue"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        formRef?.current?.submit()
                                                    }}
                                                >
                                                    {messages['devices_bulk_pairing_add']}
                                                </Button>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Form>
                                <div style={{ marginTop: 10 }}>
                                    {
                                        currenDevices?.length > 0 ? currenDevices.map((item, index) => {
                                            return (
                                                <CustomCard
                                                    key={index}
                                                    onClick={() => {
                                                        let current = currenDevices.lastIndexOf(item);
                                                        let currentCamera = currenDevices
                                                        currentCamera.splice(current, 1);
                                                        setCurrenDevices([...currentCamera]);
                                                    }}
                                                >
                                                    <div>
                                                        <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['devices_bulk_unpairing_vidfleet_esn']}</label><span>{item?.esn}</span>
                                                    </div>
                                                    <div>
                                                        <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['devices_bulk_unpairing_label']}</label><span>{item.label}</span>
                                                    </div>
                                                    <div>
                                                        <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['devices_bulk_unpairing_linked_to']}</label><span>{item.linkedto || " -- "}</span>
                                                    </div>
                                                </CustomCard>
                                            )
                                        })
                                            : <div style={{ display: 'flex', justifyContent: 'center', marginTop: 25 }} ><span style={{ opacity: 0.6 }} >{messages['no_devices_added']}</span></div>}
                                </div>
                            </>
                            :
                            <label style={{ marginBottom: 5 }}>
                                {messages['devices_bulk_unpairing_single_device']}
                            </label>
                    }
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    disabled={currenDevices.length === 0}
                    onClick={() => unPairing()}
                >
                    {single ? messages['devices_bulk_unpairing_unpair'] : messages['devices_bulk_unpairing_unpair']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default BulkUnpairing;